<script>
import edit from './editMenu'
export default {
  mixins: [edit],
  data() {
    return {
      editing: false,
    }
  },
}
</script>